import { render, staticRenderFns } from "./GridSetting.vue?vue&type=template&id=727fc1d2&scoped=true&"
import script from "./GridSetting.vue?vue&type=script&lang=js&"
export * from "./GridSetting.vue?vue&type=script&lang=js&"
import style0 from "./GridSetting.vue?vue&type=style&index=0&id=727fc1d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727fc1d2",
  null
  
)

export default component.exports